module.exports = __webpack_public_path__ + "static/man-reading-tax-documents-desktop.76440de1.webp";